import { render } from "./Toppings.vue?vue&type=template&id=6b41567e"
import script from "./Toppings.vue?vue&type=script&lang=js"
export * from "./Toppings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__